import './vendor';
import lazyLoading from './modules/lazyLoading';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
import Swiper, { Pagination, Autoplay, Navigation, EffectFade, Controller, Mousewheel, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, EffectFade,  Pagination, Controller, Mousewheel, Scrollbar ]);
import NativejsSelect from 'nativejs-select'
require('../../node_modules/jquery-mousewheel/jquery.mousewheel')
require('../../node_modules/malihu-custom-scrollbar-plugin')
require('../../node_modules/@cmyee/pushy/js/pushy.js')
require('../../node_modules/jquery-background-video/jquery.background-video.js')


$('.my-background-video').bgVideo({
	fullScreen: false, // Sets the video to be fixed to the full window - your <video> and it's container should be direct descendents of the <body> tag
	fadeIn: 500, // Milliseconds to fade video in/out (0 for no fade)
	pauseAfter: 0, // Seconds to play before pausing (0 for forever)
	fadeOnPause: false, // For all (including manual) pauses
	fadeOnEnd: true, // When we've reached the pauseAfter time
	showPausePlay: false, // Show pause/play button
	pausePlayXPos: 'right', // left|right|center
	pausePlayYPos: 'top', // top|bottom|center
	pausePlayXOffset: '15px', // pixels or percent from side - ignored if positioned center
	pausePlayYOffset: '15px' // pixels or percent from top/bottom - ignored if positioned center
});




$(".filter__all").click(function() {
	if ( $(this).parents(".filter").find(".filter__scroll").hasClass( "is-open" )) {
		$(this).parents(".filter").find(".filter__scroll").mCustomScrollbar('destroy');
	  } else{
		$(this).parents(".filter").find(".filter__scroll").mCustomScrollbar({
			axis: "y",              // вертикальный скролл
			theme: "dark",  // тема
			scrollInertia: "330",   // продолжительность прокрутки, значение в миллисекундах
			setHeight: "100%",      // высота блока (переписывает CSS)
			mouseWheel: {
			    deltaFactor: 300    // кол-во пикселей на одну прокрутку колёсика мыши
			}
		});
	  }
});



$(".menublock__categorymenu").mCustomScrollbar({
	axis: "y",              // вертикальный скролл
	theme: "dark",  // тема
	scrollInertia: "330",   // продолжительность прокрутки, значение в миллисекундах
	setHeight: "100%",      // высота блока (переписывает CSS)
	mouseWheel: {
	    deltaFactor: 300    // кол-во пикселей на одну прокрутку колёсика мыши
	}
});


$(".filter__all").click(function() {
	$(this).text(function(i, text){
		return text === "Свернуть" ? "Показать все" : "Свернуть";
	})
	$(this).parents(".filter").find(".filter__variants").toggleClass("is-open");
});


$(".pushy__city").click(function() {

	$("body").removeClass("pushy-open-left");
});



$(".catfilters__openbtn").click(function() {
	$(this).find("span").text(function(i, text){
		return text === "Свернуть" ? "Показать еще" : "Свернуть";
	})
	$(".catfilters").toggleClass("is-open");
});




$("#menu").click(function() {
	$(".menublock").addClass("is-open");
	$("body").addClass("bodyoverlay");
});

$(".menublock__close ").click(function() {
	$(".menublock").removeClass("is-open");
	$("body").removeClass("bodyoverlay");
});


const ourprojects = new Swiper('.ourprojects-slider', { 
	loop: false,
        slidesPerView: 'auto',
        paginationClickable: true,
        spaceBetween: 40,
	speed: 1000,
	rewind: true,
	navigation: {
		prevEl: '#prev-project ',
		nextEl: '#next-project',
	},
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true
	},
        breakpoints: {
            1920: {
                slidesPerView: 'auto',
            },
            1024: {
                slidesPerView: 'auto',
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});


new NativejsSelect({
	selector: '.select'
});


$('.informblock__alltext').click(function(){
        // Переключаем видимость для всех кроме первых двух параграфов
        $('.informblock__text p:nth-of-type(n+3)').toggle();
	$(this).find("span").text(function(i, text){
		return text === "Свернуть" ? "Развернуть" : "Свернуть";
	})
});

$('.gallery').slick({
	dots: false,
	speed: 1000,
	infinite: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	asNavFor: '.gallerythumb',
});

$('.gallerythumb').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	asNavFor: '.gallery',
	focusOnSelect: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				vertical: true
		    }
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				vertical: false
		    }
		},
		{
			breakpoint: 0,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				vertical: false
		    }
		}
	]
});


$(".catalog__item ").not(":first").hide();
$(".catalog__tab").click(function() {
	$(".catalog__tab").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".catalog__item").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");


$(".category-page__tabsitem ").not(":first").hide();
$(".category-page__tab ").click(function() {
	$(".category-page__tab ").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".category-page__tabsitem ").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");


$(".product-tabs__tabsitem ").not(":first").hide();
$(".product-tabs__tab").click(function() {
	$(".product-tabs__tab").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".product-tabs__tabsitem ").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");


$(".contacts-page__item ").not(":first").hide();
$(".contacts-page__tab").click(function() {
	$(".contacts-page__tab").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".contacts-page__item ").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");


$(".product-tabs__mobiletab ").click(function() {
	$(this).toggleClass("is-active");
	$(this).parents(".product-tabs__tabsitem").find(".product-tabs__tabswrapper").slideToggle();
});


$(".contacts-page__tabmobile ").click(function() {
	$(this).toggleClass("is-active");
	$(this).parents(".contacts-page__item ").find(" .contacts-page__wrapper ").slideToggle();
});



$(".filter-btn").click(function() {
	$(".filters").addClass("is-active");
	$(".filter-overlay").addClass("is-active");
});


$(".filters__close").click(function() {
	$(".filters").removeClass("is-active");
	$(".filter-overlay").removeClass("is-active");
});

$(".filter-overlay").click(function() {
	$(".filters").removeClass("is-active");
	$(this).removeClass("is-active");
});







$( ".products-slider" ).each(function(index) {
	$('.prod-slider', $(this)).slick({
		dots: false,
		speed: 1000,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: $(this).find(".btn-slider--prev"),
		nextArrow: $(this).find(".btn-slider--next"),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});
});

$('.ourteam-slider').slick({
	dots: false,
	speed: 1000,
	infinite: false,
	slidesToShow: 4,
	slidesToScroll: 4,
	arrows: false,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
			}
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		}
	]
});




/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	closeMarkup: '<span title="%title%" class="mfp-close popup-with-form__close"><svg><use xlink:href="./images/sprites.svg#close"></use></svg></span>',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});



/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	tClose: 'Закрыть окно (Esc)', 
	mainClass: 'mfp-fade mfp-img-mobile',
	
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		tCounter: '%curr% из %total%',
		tPrev: 'Предыдущий', // Alt text on left arrow
		tNext: 'Следующий',
		
		arrowMarkup: '<div title="%title%" class="gallery__arrow gallery__arrow--%dir% mfp-arrow mfp-arrow-%dir%"></div>',
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	closeMarkup: '<span title="%title%" class="mfp-close popup-gallery__close"></span>',
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});
